import { PlusIcon, Trash01Icon } from '@langchain/untitled-ui-icons';
import { Button, Input } from '@mui/joy';

function escapeString(str: string) {
  return str
    .replaceAll('\n', '\\n')
    .replaceAll('\r', '\\r')
    .replaceAll('\t', '\\t')
    .replaceAll('\b', '\\b');
}

function unescapeString(str: string) {
  return str
    .replaceAll('\\n', '\n')
    .replaceAll('\\r', '\r')
    .replaceAll('\\t', '\t')
    .replaceAll('\\b', '\b');
}

export function ManifestStopEditor(props: {
  value: unknown;
  onChange: (value: Array<string>) => void;
  readOnly?: boolean;
}) {
  const actualValue = Array.isArray(props.value)
    ? props.value.filter((i) => typeof i === 'string')
    : [];

  if (props.readOnly)
    return (
      <ul className="list-inside list-disc">
        {actualValue.map((value, index) => {
          return <li key={index}>{value}</li>;
        })}
      </ul>
    );

  return (
    <div className="flex flex-col items-start gap-2">
      {actualValue.map((value, index) => {
        return (
          <div className="flex w-full gap-2" key={index}>
            <Input
              value={escapeString(value)}
              placeholder="Stop sequence"
              sx={{ flexGrow: 1 }}
              onChange={(event) => {
                const value = event.target.value;
                props.onChange(
                  actualValue.map((v, i) =>
                    i === index ? unescapeString(value) : v
                  )
                );
              }}
              onKeyDown={(e) => {
                let character: string | null = null;

                if (e.key === 'Enter') character = '\n';
                if (e.key === 'Tab') character = '\t';

                if (character != null) {
                  e.preventDefault();

                  const target = e.target as HTMLInputElement;
                  const start = target.selectionStart ?? target.value.length;
                  const end = target.selectionEnd ?? start;

                  const toInsert = escapeString(character);
                  const newValue = [
                    target.value.slice(0, start),
                    toInsert,
                    target.value.slice(end),
                  ].join('');

                  props.onChange(
                    actualValue.map((v, i) =>
                      i === index ? unescapeString(newValue) : v
                    )
                  );

                  setTimeout(() => {
                    target.selectionStart = start + toInsert.length;
                    target.selectionEnd = start + toInsert.length;
                  }, 0);
                }
              }}
              endDecorator={
                <Button
                  variant="outlined"
                  color="neutral"
                  onClick={() => {
                    props.onChange(actualValue.filter((_, i) => i !== index));
                  }}
                >
                  <Trash01Icon className="size-4" />
                </Button>
              }
            />
          </div>
        );
      })}

      <Button
        size="sm"
        variant="outlined"
        color="neutral"
        startDecorator={<PlusIcon className="size-4" />}
        onClick={() => {
          props.onChange([...actualValue, '']);
        }}
      >
        Add stop sequence
      </Button>
    </div>
  );
}
